import { Injectable } from '@angular/core';
import { Response } from '../models';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ExecutionSidebarService {

  constructor(private http: HttpClient,
  ) { }


  launchExecution(id: string): Promise<any> {
    return this.http.post<any>(`${environment.apiUrl}/LaunchExecution`,
      {
        id
      }
    ).toPromise();
  }
}
